var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { request } from '../../../../../../..';
export const path = () => {
    return `/api/retailer/team/share/users`;
};
export const build = (options) => {
    return Object.assign({ route, url: path(), method: 'GET' }, options);
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/retailer/team/share/users';
export function execute(options) {
    const _a = build(options), { route } = _a, requestOptions = __rest(_a, ["route"]);
    return request(requestOptions);
}
export default execute;
